module.exports = __webpack_public_path__ + "28e43e0dafd25a12035353501409c1f0.svg";